import Icon from '@able/react/dist/Icon';
import TextStyle from '@able/react/dist/TextStyle';
import { AbleCommonProps } from '../Types';
import { ableTextAlias } from '../util/able-migration';
import './style.scss';

export type PillProps = {
    id?: string;
    label: string;
    type?: 'Suggestion' | 'Assist' | 'Input' | 'Required';
    onSelect?: (data: Pick<PillProps, 'id' | 'active' | 'type' | 'label' | 'variant'>, e?: any) => void;
    active?: boolean;
    variant?: "default" | "compact";
} & AbleCommonProps;

/**
 * Pill is a component can be  used to use like a button and it has selected state with three type Suggestion, Assist, Input.
 * It is recommended for better accessibility, use Pill component in a list either ordered(ol) or unordered(ul) list.
 *
 * @version 1.0.0
 */

const Pill = (props: PillProps) => {
    const { id, label, type = 'Suggestion', developmentUrl, active = false, onSelect, variant = "default", ...rest } = props;
    let iconName: any;
    const className: any = `ted-ui-pill ted-ui-pill_${type} button_${variant}`;

    if (type === 'Required') {
        return <span className={className} id={id}>
            <span className='ted-ui-pill-inner-content'>
                <TextStyle alias={ableTextAlias("Label")} element='span'>{label}</TextStyle>
            </span>
        </span>
    }

    if (type === 'Assist') iconName = 'Plus';
    else if (type === 'Input') iconName = 'Close';

    const handlePillClick = (e: any) => {
        onSelect && onSelect({
            id,
            active,
            type,
            label,
            variant
        }, e);
    }

    let ariaAttributes: React.AriaAttributes = {
        "aria-pressed": active
    }

    if (type === 'Input') {
        ariaAttributes = {
            ...ariaAttributes,
            'aria-pressed': undefined
        }
    }

    return <button className={`${className} ${active ? 'ted-ui-pill_Active' : ''}`} id={id} type='button' onClick={handlePillClick} {...ariaAttributes} {...rest}>
        <span className='ted-ui-pill-inner-content'>
            {(type === 'Assist' || type === 'Input') && <Icon icon={iconName as any} developmentUrl={developmentUrl} />}
            {(type === 'Input') && <span className='sr-only'>Clear</span>}
            <TextStyle alias={ableTextAlias("Label")} element='span'>{label}</TextStyle>
        </span>
    </button>
}

export default Pill;